import { useFeature } from '~/modules/root';

const isProductionStage = (stage: string | undefined): boolean => {
    return !!stage && ['Production', 'Staging'].includes(stage);
};

export const useBypassForcedSocial = (stage: string) => {
    const bypassForcedSocialLogin = useFeature('bypass_forced_social_signin');
    const isProduction = isProductionStage(stage);
    const bypassForcedSocial = bypassForcedSocialLogin && !isProduction;

    return {
        bypassForcedSocial,
    };
};
